<template>
  <div class="app-bread-crumb">
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="homeRoute">
              <i :class="icon"/>
            </router-link>
          </li>
          <template v-for="(item,index)  in list">
            <li :key="index">
              <router-link v-if="item.route" :to="item.route">{{ item.name }}</router-link>
              <span v-else>{{ item.name }}</span>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </div>
</template>


<script>
export default {
  name: "AppBreadCrumb",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: 'uil-home-alt'
    },
    homeRoute: {
      type: [Object, String],
      default: () => ({ name: 'company.dashboard' })
    }
  }
}
</script>


<style scoped>

</style>